import React from "react";

const UserProfileInput = ({
  fieldLabel,
  placeholder,
  name,
  value,
  onChange,
  type = "text",
  disabled = false,
}) => (
  <div className="form-group col-xl-12">
    <label className="me-sm-2">{fieldLabel}</label>
    <input
      type={type}
      className="form-control"
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);

export default UserProfileInput;
